"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const AssignmentInfo = ({ assignments, showDueDate, dueDate, phaseType }) => {
    const getCountProgressByPeer = () => {
        var _a;
        return (_a = assignments === null || assignments === void 0 ? void 0 : assignments.filter((objs) => { var _a; return ((_a = objs.peerSelection) === null || _a === void 0 ? void 0 : _a.length) === 0; })) === null || _a === void 0 ? void 0 : _a.length;
    };
    const getCountProgressByPhase = () => {
        var _a;
        return (_a = assignments === null || assignments === void 0 ? void 0 : assignments.filter((objs) => objs.state === 'in_progress')) === null || _a === void 0 ? void 0 : _a.length;
    };
    const getCountProgress = () => {
        if (phaseType === 'calibration') {
            return 1;
        }
        if (phaseType === 'peer_selection') {
            return getCountProgressByPeer();
        }
        return getCountProgressByPhase();
    };
    const countProgress = getCountProgress();
    return (react_1.default.createElement("div", { className: "flex items-center justify-between mb-[4px]" },
        react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, showDueDate && (react_1.default.createElement(react_1.default.Fragment, null,
            `${(0, HelperUtils_1.getObjectiveLocale)('Due Date')} `,
            react_1.default.createElement("span", { className: 'typography-h100 text-n-800"' }, dueDate == 'null' || !dueDate ? '-' : (0, HelperUtils_1.getDateLocale)(dueDate))))),
        countProgress > 0 && (react_1.default.createElement("span", { id: "to-complete", className: "typography-h200 text-n-600" }, (0, HelperUtils_1.getObjectiveLocale)('[num] [type] to complete')
            .replace('[num]', countProgress.toString())
            .replace('[type]', countProgress === 1 ? 'task' : 'tasks')))));
};
exports.default = AssignmentInfo;
